import React from 'react';
import { TrendingUp, Shield, DollarSign } from 'lucide-react';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-b from-navy-950 to-navy-900 pt-16">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-gold-500 rounded-full filter blur-[100px] opacity-20 animate-pulse"></div>
        <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-blue-500 rounded-full filter blur-[100px] opacity-10 animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 z-10 pt-10 pb-16">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="lg:w-1/2 mb-12 lg:mb-0 lg:pr-8">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Earn predictable income from digital assets
              <span className="block text-gold-500">without diving into crypto complexity</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              AAbA Stable unites the stability of USD-backed assets with the yield potential of DeFi in one premium, worry-free solution.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#contact" 
                className="bg-gold-500 hover:bg-gold-600 text-navy-900 font-semibold px-8 py-3 rounded-md transition-all transform hover:scale-105 text-center"
              >
                Let's Connect
              </a>
              <a 
                href="#why" 
                className="bg-transparent border-2 border-gray-400 hover:border-white text-white font-semibold px-8 py-3 rounded-md transition-colors text-center"
              >
                Learn More
              </a>
            </div>
          </div>

          <div className="lg:w-1/2 relative">
            <div className="bg-navy-800 bg-opacity-80 backdrop-blur-lg rounded-2xl p-8 border border-gray-700 shadow-xl max-w-lg mx-auto transform transition-all hover:translate-y-[-5px]">
              <div className="flex items-center justify-center gap-6 mb-8">
                <div className="flex flex-col items-center">
                  <div className="bg-navy-700 p-3 rounded-full mb-2">
                    <Shield className="w-8 h-8 text-gold-500" />
                  </div>
                  <span className="text-gray-300 text-sm">Secure</span>
                </div>
                <div className="flex flex-col items-center">
                  <div className="bg-navy-700 p-3 rounded-full mb-2">
                    <DollarSign className="w-8 h-8 text-gold-500" />
                  </div>
                  <span className="text-gray-300 text-sm">Stable</span>
                </div>
                <div className="flex flex-col items-center">
                  <div className="bg-navy-700 p-3 rounded-full mb-2">
                    <TrendingUp className="w-8 h-8 text-gold-500" />
                  </div>
                  <span className="text-gray-300 text-sm">Profitable</span>
                </div>
              </div>

              <div className="mb-6 border-b border-gray-700 pb-6">
                <div className="flex justify-between mb-2">
                  <span className="text-gray-300">Expected Quarterly Returns</span>
                  <span className="text-gold-500 font-semibold">7-31% APY</span>
                </div>
                <div className="w-full bg-navy-700 rounded-full h-2">
                  <div className="bg-gradient-to-r from-gold-500 to-gold-400 h-2 rounded-full w-[75%]"></div>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <span className="text-gray-200">100% USD-backed stablecoins</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <span className="text-gray-200">Predictable quarterly income</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center flex-shrink-0">
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                    </svg>
                  </div>
                  <span className="text-gray-200">Flexible withdrawal options</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;